import { AppState } from './app';
import * as constants from '../constants';
import { addToSSObject } from '../utils/react';

// We type the payload cast inside each switch case:
export type AgencyActionType = {
  type:
    | typeof constants.SET_AGENCY_INFO_PANEL_VISIBILITY
    | typeof constants.SET_IS_AGENCY_MODE
    | typeof constants.SET_AGENCY_DATA
    | typeof constants.FETCHED_CUSTOMERS
    | typeof constants.FETCHED_USER_INFO
    | typeof constants.SELECT_CUSTOMER;
  payload: any;
};

export const agencyReducer = (state: AppState, action: AgencyActionType) => {
  switch (action.type) {
    case constants.SET_AGENCY_INFO_PANEL_VISIBILITY: {
      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          agencyInfoPanelVisibility: action.payload,
        },
      };
    }

    case constants.SET_IS_AGENCY_MODE: {
      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          isAgencyJourney: action.payload,
        },
      };
    }

    case constants.SET_AGENCY_DATA: {
      addToSSObject('userDataEC', 'agencyData', action.payload);
      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          agencyData: action.payload,
        },
      };
    }

    // This seems like legacy Agency state:
    case constants.FETCHED_CUSTOMERS: {
      //static records as backend return empty
      // const dummyCustomers = [
      //     {
      //         customerid: 12345001,
      //         customercontactid: 123456001,
      //         branchelabel: 'BMW',
      //         display: 'BMW Schweiz AG',
      //         branche: 'BMW',
      //     },
      //     {
      //         customerid: 12345002,
      //         customercontactid: 123456002,
      //         branchelabel: 'BMW',
      //         display: 'Schweiz AG',
      //         branche: 'BMW',
      //     },
      // ];

      return {
        ...state,
        customersForAgency: action.payload.data.customers,
        linkToNewCustomer: action.payload.data.linktonewcustomer,
        // customersForAgency: dummyCustomers,
      };
    }

    case constants.SELECT_CUSTOMER: {
      return {
        ...state,
        selectedCustomer: action.payload,
      };
    }

    case constants.FETCHED_USER_INFO: {
      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          userInfo: action.payload.data,
          isAgency: action.payload.data.role === 4 || action.payload.data.role === 5,
          // ToDo: check if we need isAgency flag or we can merge these two
          isAgencyJourney: action.payload.data.role === 4 || action.payload.data.role === 5,
        },
      };
    }
  }
};
